"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

require("core-js/modules/es6.function.bind.js");

require("core-js/modules/es6.function.name.js");

var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactComponents = require("@ucloud-fe/react-components");

var _localeConsumerDecorator = require("../../utils/localeConsumerDecorator");

var _Edit = _interopRequireDefault(require("@ucloud/ucloud-icons/dist/uc-action/svgr/Edit"));

var _zh_CN = _interopRequireDefault(require("./locale/zh_CN"));

var _index = require("./style/index");

var _Typography = _interopRequireDefault(require("../Typography"));

var _TextEllipsis = _interopRequireDefault(require("../TextEllipsis"));

var _excluded = ["remark", "name", "onEdit", "onNameClick"];

var _this = void 0;

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Text = _Typography["default"].Text;
var LineEllipsis = _TextEllipsis["default"].LineEllipsis;
var HoverDisplayArea = _reactComponents.Table.HoverDisplayArea;
/* eslint-disable react/prop-types */

var EditIcon = function EditIcon(_ref) {
  (0, _newArrowCheck2["default"])(this, _this);
  var locale = _ref.locale,
      onEdit = _ref.onEdit;
  if (!onEdit) return null;
  return /*#__PURE__*/_react["default"].createElement(_reactComponents.Tooltip, {
    popup: /*#__PURE__*/_react["default"].createElement(Text, {
      size: "t1"
    }, locale.modify)
  }, /*#__PURE__*/_react["default"].createElement(_index.StyledIcon, {
    onClick: onEdit
  }, /*#__PURE__*/_react["default"].createElement(_Edit["default"], null)));
}.bind(void 0);
/**
 * NameRemark
 * @description 展示名称和/或备注
 */


var NameRemark = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(NameRemark, _PureComponent);

  var _super = _createSuper(NameRemark);

  function NameRemark(props) {
    (0, _classCallCheck2["default"])(this, NameRemark);
    return _super.call(this, props);
  }

  (0, _createClass2["default"])(NameRemark, [{
    key: "getNameClassName",
    value: function getNameClassName(cls) {
      var withEdit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return withEdit ? "".concat(cls, " ").concat(_index.withEditCls) : cls;
    }
  }, {
    key: "renderName",
    value: function renderName() {
      var _this$props = this.props,
          name = _this$props.name,
          onNameClick = _this$props.onNameClick,
          remark = _this$props.remark,
          locale = _this$props.locale,
          onEdit = _this$props.onEdit;
      var withEdit = onEdit && remark === null;

      if ((0, _isFunction2["default"])(onNameClick)) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _index.contentCls
        }, /*#__PURE__*/_react["default"].createElement(Text, {
          className: this.getNameClassName(_index.nameCls, withEdit),
          color: "dark",
          onClick: onNameClick,
          isLink: true
        }, /*#__PURE__*/_react["default"].createElement(LineEllipsis, {
          text: name
        })), remark === null ? /*#__PURE__*/_react["default"].createElement(HoverDisplayArea, {
          className: _index.editIconCls
        }, /*#__PURE__*/_react["default"].createElement(EditIcon, {
          locale: locale,
          onEdit: onEdit
        })) : null);
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _index.contentCls
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: this.getNameClassName(_index.nameCls, withEdit)
      }, /*#__PURE__*/_react["default"].createElement(LineEllipsis, {
        text: name
      })), remark === null ? /*#__PURE__*/_react["default"].createElement(HoverDisplayArea, {
        className: _index.editIconCls
      }, /*#__PURE__*/_react["default"].createElement(EditIcon, {
        locale: locale,
        onEdit: onEdit
      })) : null);
    }
  }, {
    key: "renderRemark",
    value: function renderRemark() {
      var _this$props2 = this.props,
          remark = _this$props2.remark,
          locale = _this$props2.locale,
          onEdit = _this$props2.onEdit,
          placeholder = _this$props2.placeholder;

      if (remark === null) {
        return null;
      }

      var cls = remark ? _index.remarkCls : _index.placeholderCls;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _index.contentCls
      }, /*#__PURE__*/_react["default"].createElement(LineEllipsis, {
        className: this.getNameClassName(cls, !!onEdit),
        text: remark || placeholder || locale.remarkTip
      }), /*#__PURE__*/_react["default"].createElement(HoverDisplayArea, {
        className: _index.editIconCls
      }, /*#__PURE__*/_react["default"].createElement(EditIcon, {
        locale: locale,
        onEdit: onEdit
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          remark = _this$props3.remark,
          name = _this$props3.name,
          onEdit = _this$props3.onEdit,
          onNameClick = _this$props3.onNameClick,
          others = (0, _objectWithoutProperties2["default"])(_this$props3, _excluded);
      return /*#__PURE__*/_react["default"].createElement(_index.StyledWrapper, others, this.renderName(), this.renderRemark());
    }
  }]);
  return NameRemark;
}(_react.PureComponent);

NameRemark.propTypes = {
  /**
   * 名称，若传入node，请注意使用行内元素或行内布局，否则宽度溢出隐藏出...功能会失效
   */
  name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,

  /**
   * 备注，传null则隐藏备注栏
   */
  remark: _propTypes["default"].string,

  /**
   * 备注栏的placeholder
   */
  placeholder: _propTypes["default"].string,

  /**
   * 点击编辑图标回调，不传则隐藏编辑图标
   */
  onEdit: _propTypes["default"].func,

  /**
   * 点击名称回调，名称显示为链接样式
   */
  onNameClick: _propTypes["default"].func,

  /** @ignore */
  locale: _propTypes["default"].object,

  /** @ignore */
  className: _propTypes["default"].string
};
NameRemark.defaultProps = {};

var _default = (0, _localeConsumerDecorator.localeConsumerDecorator)({
  defaultLocale: _zh_CN["default"],
  localeName: "UI_NameRemark"
})(NameRemark);

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/NameRemark/NameRemark.js
// module id = 2108
// module chunks = 6 7 17 18